import React from 'react';
import Div from '../Element/Div/Div';
import hiddenStyles from '../Element/Hidden.module.scss';
import styles from './BackgroundImage.module.scss';
import { CreateProps } from '../../types/utils/CreateProps';

type BackgroundImageProps = CreateProps<
  {
    /** source */
    src: string;
    /** alt text */
    alt: string;
    /** mobile resolution source */
    mobileSrc?: string;
    /** Make image scale with original aspect ratio */
    scaleWithOriginalAspectRatio?: boolean;
  },
  typeof Div
>;

const BackgroundImage: React.FunctionComponent<BackgroundImageProps> = ({
  src,
  mobileSrc,
  alt,
  style,
  scaleWithOriginalAspectRatio,
  className,
  ...props
}) => {
  const classNames = [
    styles.backgroundImage,
    {
      [styles.backgroundImage__scaleWithOriginalAspectRatio]: scaleWithOriginalAspectRatio,
    },
    className,
  ];

  const responsiveSpaceClassNamesForDesktop = [
    styles.backgroundImage_responsiveSpace,
    {
      [hiddenStyles.hidden__thinnerThanLg]: !!mobileSrc,
    },
  ];

  const responsiveSpaceClassNamesForMobile = [
    styles.backgroundImage_responsiveSpace,
    hiddenStyles.hidden__widerThanMd,
  ];

  const inlineStylesForDesktop = {
    ...style,
    backgroundImage: `url(${src})`,
  };

  const inlineStylesForMobile = {
    ...style,
    backgroundImage: `url(${mobileSrc})`,
  };

  return (
    <Div className={classNames} {...props}>
      <Div className={responsiveSpaceClassNamesForDesktop}>
        <div
          className={styles.backgroundImage_image}
          style={inlineStylesForDesktop}
        />
      </Div>

      {mobileSrc && (
        <Div className={responsiveSpaceClassNamesForMobile}>
          <div
            className={styles.backgroundImage_image}
            style={inlineStylesForMobile}
          />
        </Div>
      )}

      <span className={hiddenStyles.visuallyHidden}>{alt}</span>
    </Div>
  );
};

export default BackgroundImage;
